import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import {DocumentService} from '../../../services/document.service';
import {PacientService} from '../../../services/pacient.service';
import {LoadingController} from '@ionic/angular';

@Component({
    selector: 'app-atendimento-detalhe-component',
    templateUrl: 'atendimento-detalhe-component.html',
    styleUrls: ['./atendimento-detalhe-component.scss']
})

export class AtendimentoDetalheComponent implements OnInit {
    list: any = {
        diagnosticos: [],
        procedimentos: [],
        org: {
            cnes: '-',
            nome: '-',
            telefone: '-',
        },
        geral: {
            dtStart: '-',
            dtEnd: '-',
        },
    };
    user: any;

    @Input() atendimento: any;
    @Output() atendimentoVoltar = new EventEmitter();

    constructor(
        private document: DocumentService,
        private pacient: PacientService,
        private loadingCtrl: LoadingController,
    ) {
    }

    async ngOnInit() {
        await this.getDetalhe();
    }

    async getDetalhe() {
        let loading = await this.loadingCtrl.create({});
        await loading.present();
        console.log('-------------------->entrou');

        this.user = await this.pacient.getInfo();
        this.list = await this.document.loadDetailCMD(this.atendimento);
        console.log('-------------------->list', this.list);
        await loading.dismiss();
    }

    async voltar() {
        this.atendimentoVoltar.emit();
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/)
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
        return null
    }

}
